

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const paymentMadeAtom = atom({key:'paymentMadeAtom', default:{deposit_info:[], deposit_method:[]}});


export  const SetPaymentMadeAtom = () => useSetRecoilState(paymentMadeAtom);
export  const GetPaymentReceiveAtom = () => useRecoilValue(paymentMadeAtom);





